module.exports = __webpack_public_path__ + "static/media/nivel_esg.9f54548f.png";